module.exports = __webpack_public_path__ + "img/score-5.0e797d18.png";